import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=2ddb0444&scoped=true"
import script from "./detalle.vue?vue&type=script&lang=js"
export * from "./detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb0444",
  null
  
)

export default component.exports